import useTranslation from 'next-translate/useTranslation';

import { useMainModalSmallScreenLayout } from './useMainModalSmallScreenLayout';

/**
 * Returns the invite-team-later action label: short copy on narrow viewports, full copy otherwise.
 */
export function useInviteTeamLaterButtonLabel(): string {
  const { t } = useTranslation('onboarding');
  const isSmallScreen = useMainModalSmallScreenLayout();

  return t(isSmallScreen
    ? 'invite_members_step.optimization_b.invite_team_later_btn_short'
    : 'invite_members_step.optimization_b.invite_team_later_btn');
}
